import React from "react";

const FiltresEquipement = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedFilters = { ...filters };

    if (type === "checkbox") {
      updatedFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      updatedFilters[name] = value;
    }

    onChange(updatedFilters);
  };

  const uniqueTypeEquipement = [
    ...new Set(annonces.map((a) => a.typeEquipement).filter(Boolean)),
  ];

  const uniqueEtat = [
    ...new Set(annonces.map((a) => a.etat).filter(Boolean)),
  ];

  return (
    <div>
      <h3>Type d'équipement</h3>
      {uniqueTypeEquipement.map((typeEquipement) => (
        <label key={typeEquipement}>
          <input
            type="checkbox"
            name="typeEquipement"
            value={typeEquipement}
            onChange={handleChange}
          />
          {typeEquipement}
        </label>
      ))}

      <h3>État</h3>
      {uniqueEtat.map((etat) => (
        <label key={etat}>
          <input
            type="checkbox"
            name="etat"
            value={etat}
            onChange={handleChange}
          />
          {etat}
        </label>
      ))}

      <h3>Prix</h3>
      <label>
        Min:
        <input
          type="number"
          name="prixMin"
          value={filters.prixMin}
          onChange={handleChange}
          placeholder="Prix minimum"
        />
      </label>
      <label>
        Max:
        <input
          type="number"
          name="prixMax"
          value={filters.prixMax}
          onChange={handleChange}
          placeholder="Prix maximum"
        />
      </label>
    </div>
  );
};

export default FiltresEquipement;
